_ = require('lodash')

angular.module('workflow.app')

.factory( 'StepModifier', ( Model, $q, Api, Utils ) ->

  class StepModifier extends Model

    init: ->
      @curated_sources = @curated_sources || []
      @custom_sources  = @custom_sources || []
      @sources         = @sources || []

    upsert: ->
      @upsertResource( @ )

    # TODO: Refactor. Should move to Model
    upsertResource: ( resource ) ->
      resource[ if resource.id? then '$update' else '$save' ]()

    addCustomSource: ( source ) ->
      @addSource( source, @custom_sources )

    getCustomSources: () ->
      return @custom_sources

    removeCustomSource: ( source ) ->
      @removeSource( source, @custom_sources )

    addCuratedSource: ( source ) ->
      @addSource( source, @curated_sources )

    getCuratedSources: () ->
      return @curated_sources

    removeCuratedSource: ( source ) ->
      @removeSource( source, @curated_sources )

    addSource: ( source, collection ) ->
      @markAsDirty( @ )
      collection.push( source )

    removeSource: ( source, collection ) ->
      @markAsDirty( @ )
      _.pull( collection, source )

    toggleSourceExclusion: ( source ) ->
      if @isExcluded( source )
        @unExclude( source )
      else
        @exclude( source )

    getExcludedSourceById: ( id ) ->
      Utils.getArrayItemById( @sources, id )

    isExcluded: ( source ) ->
      return @getExcludedSourceById( source.id ) != undefined

    exclude: ( source ) ->
      @sources.push
        id: source.id

    unExclude: ( source ) ->
      itemToRemove = @getExcludedSourceById( source.id )
      Utils.removeItemFromArray( @sources, itemToRemove )

    isDirty: ->
      isResourceDirty( @ )

    # Private methods

    # TODO: Refactor. Should move to Model
    isResourceDirty = ( resource ) ->
      resource.hasOwnProperty( '$$dirty' ) and resource.$$dirty == true

)
